module.exports = __webpack_public_path__ + "img/15.65d377b1.jpg";